import {ERROR} from '@di-shared/const';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

function UbiContentsError() {
  const {t} = useInferableTranslation();
  const {defaultDistanceSymbol} = useUnitConverter();

  return (
    <main className="content page_ubi">
      <section className="section">
        <div className="section_heading type_main">
          <h2
            className="section_heading_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20020')}
          </h2>
        </div>
        <div className="section_container">
          <div className="ubi_my">
            <ul className="ubi_my_list">
              <li className="ubi_my_item">
                <span className="ubi_my_key">{t('T20021')}</span>
                <span className="ubi_my_val">{t('T20006_$score', {score: ERROR.DASH})}</span>
              </li>
              <li className="ubi_my_item">
                <span className="ubi_my_key">{t('T20022')}</span>
                <span className="ubi_my_val">
                  {ERROR.DASH}
                  {defaultDistanceSymbol}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div className="divider divider_thick"></div>
      <section className="section section_notice">
        <ul className="notice_list">
          <li className="notice_item">{t('T20028')}</li>
          <li className="notice_item">{t('T20029')}</li>
          <li className="notice_item">{t('T20030')}</li>
        </ul>
      </section>
    </main>
  );
}

export default UbiContentsError;
